export default __webpack_public_path__ + "static/media/notch.b7696bac.jpg";